import MyTicketsPage, { MyTicketsPageProps } from './MyTicketsPage';
import withInteractor from './MyTicketsPage.interactor';
import withPresenter from './MyTicketsPage.presenter';

export type { MyTicketsPageProps };

export default withInteractor(withPresenter(MyTicketsPage));
